// extracted by mini-css-extract-plugin
module.exports = {"divider":"AdminNavigationComponent_divider__2n-Tc"};